var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "#999999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M23 3.83301C17.9784 3.83301 13.8959 7.91551 13.8959 12.9372C13.8959 17.863 17.7484 21.8497 22.77 22.0222C22.9234 22.003 23.0767 22.003 23.1917 22.0222C23.23 22.0222 23.2492 22.0222 23.2875 22.0222C23.3067 22.0222 23.3067 22.0222 23.3259 22.0222C28.2325 21.8497 32.085 17.863 32.1042 12.9372C32.1042 7.91551 28.0217 3.83301 23 3.83301Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.7367 27.121C27.3892 23.556 18.6684 23.556 13.2825 27.121C10.8484 28.7502 9.50671 30.9543 9.50671 33.3118C9.50671 35.6693 10.8484 37.8544 13.2634 39.4644C15.9467 41.266 19.4734 42.1669 23 42.1669C26.5267 42.1669 30.0534 41.266 32.7367 39.4644C35.1517 37.8352 36.4934 35.6502 36.4934 33.2735C36.4742 30.916 35.1517 28.731 32.7367 27.121Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSender);
export default __webpack_public_path__ + "static/media/sender.a15f985ab9a3655700bbbaca85a1cb15.svg";
export { ForwardRef as ReactComponent };